import React from "react";
import { TextareaAutosizeProps } from "@mui/base/TextareaAutosize";
import { Grid, styled } from "@mui/material";
import { Csizes } from "@/shared/theme/theme";
import MxInputLabel from "../MxInputLabel";
export interface IMxTextAreaFieldProps extends TextareaAutosizeProps {
  name?: string;
  placeholder?: string;
  rows?: number;
  error?: boolean;
  label?: string;
}

const MxTextAreaField = (props: IMxTextAreaFieldProps) => {
  const focusRef = React.useRef(false);
  const onFocus = (e: React.FocusEvent<HTMLDivElement>) => {
    focusRef.current = true;
  };

  const shrink = Boolean(props.value) || focusRef.current;
  const placeholder = props?.label && !focusRef.current ? "" : props?.placeholder;
  return (
    <ContentTextArea
      container
      item
      xs={12}
      position="relative"
      onFocus={onFocus}
      onBlur={() => (focusRef.current = false)}
      className="MxTextAreaField"
      data-testid={`${props.id || props.name}-text-area-field`}
    >
      <MxInputLabel
        shrink={shrink}
        htmlFor={props.id}
        children={props.label ?? ""}
        data-testid={`${props.id || props.name}-label`}
      />

      <textarea
        {...props}
        placeholder={placeholder}
        data-testid={`${props.id || props.name}-textarea`}
      ></textarea>
    </ContentTextArea>
  );
};

export default MxTextAreaField;

const ContentTextArea = styled(Grid)(({ theme }) => ({
  "& textarea": {
    transition: "all 0.2s ease-in-out",
    boxSizing: "border-box",
    width: "100%",
    minHeight: Csizes.input,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.5,
    padding: 12,
    borderRadius: 8,
    marginBottom: 0,
    border: "1px solid #d1d7e1",
    backgroundColor: "#fff",
    color: "black",
    outline: "none",
    boxShadow: "none",
    "&::placeholder": {
      fontSize: 12,
      color: theme.palette.grey[400]
    },

    "&[disabled]": {
      backgroundColor: "#f1f5f9",
      cursor: "not-allowed;;"
    },

    "&:focus-visible": {
      borderColor: "#1f3564",
      border: "2px solid #1f3564"
    },
    "&:hover": {
      borderColor: "#1f3564",
      border: "1px solid #1f3564"
    },
    "&:focus": {
      borderColor: "#1f3564",
      backgroundColor: "#fff",
      border: "2px solid #1f3564",
      transition: "all 0.1s ease-in-out"
    }
  }
}));
